import {useEffect, useRef, useState} from 'react';
import {LinkSprite} from './LinkSprite';
import {TRANSFER_RING_DURATION_MS} from './TransferRingAnimation';
import {useNetworkNodes, useNetworkOwnership} from '../state/networkHooks';
import {Link} from '../state/networkStore';
import {useTransferRingListenerForLink} from '../state/RingTransferListenerSlice';
import {TransferRingEvent} from '../SupplyChainPayloadTypes';

interface LinkSpriteProps {
    link: Link;
}

export function PlayLink({link}: LinkSpriteProps) {
    const nodes = useNetworkNodes();
    const ownership = useNetworkOwnership();

    const playerA = ownership[link.nodeIdA];
    const playerB = ownership[link.nodeIdB];
    const nodeA = nodes[link.nodeIdA];
    const nodeB = nodes[link.nodeIdB];

    const [pending, acknowledge] = useTransferRingListenerForLink(playerA, playerB);
    const [activeTransfer, setActiveTransfer] = useState<TransferRingEvent | undefined>();
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    // console.log(`PlayLink for ${playerA} [node: ${link.nodeIdA}] -> ${playerB} [node: ${link.nodeIdB}] ACTIVE:`, activeTransfer);
    useEffect(() => {
        if (!activeTransfer && pending.length > 0) {
            const next = pending[0];
            setActiveTransfer(next);
            acknowledge(next);
            timerRef.current = setTimeout(() => setActiveTransfer(undefined), TRANSFER_RING_DURATION_MS);
        }
    }, [pending, activeTransfer, acknowledge]);

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, []);

    const fromAtoB = activeTransfer?.sourcePlayerId === playerA;

    return (
        <LinkSprite
            nodeA={nodeA}
            nodeB={nodeB}
            relationship={link.relationship}
            activeTransfer={activeTransfer}
            fromAtoB={fromAtoB}
        />
    );
}
